/**
 * @author Kelnik
 *
 * FlexAccordion - с наследованием класса Accordion
 * разница в том что тут работает max-height за место height
 */

import Accordion from 'components/accordion/index';

class FlexAccordion extends Accordion {
    constructor() {
        super();

        this.activeClass = 'is-active';
    }

    /**
     * Установка элементов
     * @param {Object} options - опции
     * @private
     */
    _setOptions(options) {
        this.target = options.target;
        this.header = this.target.querySelector(options.header || '.j-flex-accordion-toggle');
        this.content = this.target.querySelector(options.content || '.j-flex-accordion-content');
    }

    /**
     * Установка высоты обертке контента
     * @param {number} height - высота
     * @private
     */
    _setHeightContentWrapper(height) {
        this.content.style.maxHeight = `${height}px`;
    }

    /**
     * Обновление высоты обертки контента
     * @private
     */
    _updateHeightContent() {
        const height = this.content.scrollHeight;

        this._setHeightContentWrapper(height);
    }
}

export default FlexAccordion;
